import { z } from "zod";
import { WeekdayEnum } from "./Weekday";
import { TimeOfDaySchema } from "./TimeOfDay";

export const WeeklyHoursSchema = z.array(
  z.tuple([WeekdayEnum, /* from: */ TimeOfDaySchema, /* to: */ TimeOfDaySchema]),
);

export type WeeklyHours = z.infer<typeof WeeklyHoursSchema>;
